module.exports = __webpack_public_path__ + "media/assets/images/file-icon-c9cfa9055a47f19fdbaafee00ef8b2e9.svg";